import { backIcon } from '@/images'
import { GxIcon } from '@garpix/garpix-web-components-react'
import classNames from 'classnames'
import React from 'react'
import { Link } from 'react-router-dom'
import style from './styles/back_link.module.scss'

const BackLink = ({
  title = '',
  href = '/',
  className = ''
}): React.ReactElement => {
  return (
    <Link
      to={href}
      className={classNames({
        [style.back]: true,
        [className]: className
      })}
    >
      <GxIcon src={backIcon} className={style.back__icon} />
      {title}
    </Link>
  )
}

export default BackLink
